import { PipeTransform, Pipe } from '@angular/core';
import { DueDate } from '../../enums/due-date.enum';
import { IdName } from '../../models/id-name.model';
import { enumToList } from '../enum-to-list';

@Pipe({
  name: 'dueDate',
  standalone: false
})
export class DueDatePipe implements PipeTransform {
  public transform(value: DueDate): string {
    return getDueDate(value);
  }
}

export function getDueDate(value: DueDate): string {
  switch (value) {
    case DueDate.Overdue:
      return 'Overdue';
    case DueDate.DueWithin30Days:
      return 'Due within 30 days';
    case DueDate.DueWithin60Days:
      return 'Due within 60 days';
    case DueDate.DueWithin120Days:
      return 'Due within 120 days';
    case DueDate.DueWithinYear:
      return 'Due within 1 year';
    default:
      throw new Error(`Unsupported value for DueDate: ${value}.`);
  }
}

export function getDueDateList(): IdName[] {
  return enumToList(DueDate, getDueDate);
}
